import { customerJson, CustomerApiError } from './customerApi';
import { AUTH_REQUIRED_MESSAGE } from '../utils/customerAuth';
import { authService } from './auth';

type WishlistApiResponse = { success: boolean; data?: unknown[]; message?: string };

export const wishlistService = {
  async getWishlist(): Promise<WishlistApiResponse> {
    if (!authService.isCustomerAuthenticated()) {
      throw new CustomerApiError(AUTH_REQUIRED_MESSAGE, 401, 'AUTH_REQUIRED');
    }
    return customerJson<WishlistApiResponse>('/wishlist');
  },

  async addToWishlist(productId: string): Promise<{ success: boolean; message?: string }> {
    if (!authService.isCustomerAuthenticated()) {
      throw new CustomerApiError(AUTH_REQUIRED_MESSAGE, 401, 'AUTH_REQUIRED');
    }
    return customerJson('/wishlist', {
      method: 'POST',
      body: JSON.stringify({ productId }),
    });
  },

  async removeFromWishlist(productId: string): Promise<{ success: boolean; message?: string }> {
    if (!authService.isCustomerAuthenticated()) {
      throw new CustomerApiError(AUTH_REQUIRED_MESSAGE, 401, 'AUTH_REQUIRED');
    }
    return customerJson(`/wishlist/${productId}`, { method: 'DELETE' });
  },

  async clearWishlist(): Promise<{ success: boolean; message?: string }> {
    return customerJson('/wishlist', { method: 'DELETE' });
  },
};
